import { addDays, istanbulDay, lastDays, type ReportRange } from "@ewn/shared";

/**
 * The ranges an operator asks about most, on the Istanbul clock the report
 * cuts its days on. Computed from `now`, so a test can say what now is.
 */
export const PRESETS = ["today", "7d", "30d", "month", "lastMonth"] as const;
export type Preset = (typeof PRESETS)[number];

export const PRESET_LABEL: Record<Preset, string> = {
  today: "Today",
  "7d": "Last 7 days",
  "30d": "Last 30 days",
  month: "This month",
  lastMonth: "Last month",
};

export function presetRange(preset: Preset, now: Date): ReportRange {
  const today = istanbulDay(now);
  const firstOfMonth = `${today.slice(0, 8)}01`;
  switch (preset) {
    case "today":
      return { from: today, to: today };
    case "7d":
      return lastDays(7, now);
    case "30d":
      return lastDays(30, now);
    case "month":
      return { from: firstOfMonth, to: today };
    case "lastMonth": {
      const lastDay = addDays(firstOfMonth, -1);
      return { from: `${lastDay.slice(0, 8)}01`, to: lastDay };
    }
  }
}

/** The preset a range is, if it is one, for the button to show pressed. */
export function presetOf(range: ReportRange, now: Date): Preset | null {
  return (
    PRESETS.find((preset) => {
      const candidate = presetRange(preset, now);
      return candidate.from === range.from && candidate.to === range.to;
    }) ?? null
  );
}
